import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { LazyLoadEvent, ScrollerOptions } from 'primeng/api';
import { cloneDeep } from 'lodash';
import { LazyTreeViewService } from './lazy-tree-view.service';
import { LazyTreeNode } from '@core/models/models';

@Component({
  selector: 'caremoni-lazy-tree-view',
  templateUrl: './lazy-tree-view.component.html',
  styleUrls: ['./lazy-tree-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [LazyTreeViewService]
})
export class LazyTreeViewComponent implements OnInit, OnChanges {

  @Input() data: any[] = [];
  @Input() dataNode: any;
  @Input() dragScope: string = "";
  @Input() scrollHeight: number = 0;
  @Input() rowHeight: number = 0;
  @Input() nodeClicked: LazyTreeNode = new LazyTreeNode();
  @Input() isZaitaku: boolean = false;
  @Output() nodeClick = new EventEmitter<LazyTreeNode>();
  @Output() leafNodeClick = new EventEmitter<LazyTreeNode[]>();
  @Input() isReLoadData?: boolean = false;
  

  eventLoading: any;
  virtualData: LazyTreeNode[] = [];
  options: ScrollerOptions = {};
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.virtualData = Array.from({length: this.data.length});
      if (this.isZaitaku) this.virtualData = cloneDeep(this.data);
      //load data of required page
      let loadedItems = [...this.data].slice(0, 1);
      // //populate page of virtual items
      this.virtualData.splice(0, 1,...loadedItems);
      // //trigger change detection
      this.virtualData = [...this.virtualData];
      
      if(this.eventLoading && this.isReLoadData) {
        this.loadData(this.eventLoading);
      }
    }
  }

  ngOnInit(): void {
    this.virtualData = Array.from({length: this.data.length});
  }

  loadData(event: LazyLoadEvent) {
    this.eventLoading = event;
    if (!event.first && event.last === 1 && this.virtualData[0]) {
      return;
    } 

    //load data of required page
    let loadedCars = [...this.data].slice(event.first, event.last);

    // //populate page of virtual cars
    this.virtualData.splice(event.first ?? 0, (event.last ?? 0) - (event.first || 0),...loadedCars);
    
    // //trigger change detection
    this.virtualData = [...this.virtualData];
 
  }


  handleClick(node: LazyTreeNode) {
    this.nodeClick.emit(node);
  }

  onClickLeafNode(nodesSelected: LazyTreeNode[]) {
    this.virtualData.forEach(element => {
      if (element) {
        element.selected = nodesSelected.some((x:any) => x.id == element.id);
        if (element.node) element.node.selected = nodesSelected.some((x:any) => x.id == element.id);
      }
    });
    this.leafNodeClick.emit(nodesSelected);
  }
}
